module.exports = __webpack_public_path__ + "static/media/footer.de709cf9.png";